import { render, staticRenderFns } from "./SortableItem.vue?vue&type=template&id=2c1837bd&scoped=true"
import script from "./SortableItem.vue?vue&type=script&lang=js"
export * from "./SortableItem.vue?vue&type=script&lang=js"
import style0 from "./SortableItem.vue?vue&type=style&index=0&id=2c1837bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1837bd",
  null
  
)

export default component.exports